<template>
  <div>
    <div class="mb-2">
      <div class="text-xs-right">
        <v-btn dark depressed color="primary" @click="showAdvancedSearch = !showAdvancedSearch">
          <v-icon>search</v-icon>
          &nbsp;
          {{ $t('advanced search') }}&nbsp;
          <i v-if="!showAdvancedSearch" class="fas fa-angle-down"></i>
          <i v-else class="fas fa-angle-up"></i>
        </v-btn>
        <exportxlsx :promised-value="getXlsxData"></exportxlsx>
      </div>
      <div
        v-if="showAdvancedSearch"
        class="mb-4 pa-2"
        style="border: 1px solid #eee; border-radius: 10px; position: relative"
      >
        <v-layout class="pa-0 ma-0" wrap row>
          <v-flex xs12 sm3 class="form-control pa-1">
            <label>{{ $t('รหัสสมาชิก') }}</label>
            <input v-model="filter.toa_member_id" class="form-control" type="text" />
          </v-flex>
          <v-flex xs12 sm3 class="form-control pa-1">
            <label>{{ $t('ชื่อ-สกุล') }}</label>
            <input v-model="filter.name" class="form-control" type="text" />
          </v-flex>
          <v-flex xs12 sm3 class="form-control pa-1">
            <label>{{ $t('เลขบัตรประชาชน') }}</label>
            <input v-model="filter.identityNumber" class="form-control" type="text" />
          </v-flex>
          <v-flex xs12 sm3 class="form-control pa-1">
            <label>{{ $t('เบอร์โทรศัพท์') }}</label>
            <input v-model="filter.phoneNumber" class="form-control" type="text" />
          </v-flex>
          <v-flex xs12 sm3 class="form-control pa-1">
            <label>{{ $t('อาชีพ') }}</label>
            <multiselect
              v-model="filter.job"
              :options="jobOptions"
              :searchable="false"
              selected-label
              deselect-label
              :multiple="false"
              :allow-empty="true"
            ></multiselect>
          </v-flex>
          <v-flex xs12 sm3 class="form-control pa-1">
            <label>{{ $t('ห้าง') }}</label>
            <multiselect
              v-model="filter.departmentStore"
              :options="departmentOptions"
              :searchable="false"
              selected-label
              deselect-label
              :multiple="false"
              :allow-empty="true"
              @input="filter.branch = ''"
            ></multiselect>
          </v-flex>
          <v-flex xs12 sm3 class="form-control pa-1">
            <label>{{ $t('สาขา') }}</label>
            <multiselect
              v-model="filter.branch"
              :options="branchOptions"
              :searchable="false"
              selected-label
              deselect-label
              :multiple="false"
              :allow-empty="true"
            ></multiselect>
          </v-flex>
          <v-flex xs12 sm3 class="form-control pa-1">
            <label>{{ $t('Tier') }}</label>
            <multiselect
              v-model="filter.tier"
              :options="tierOptions"
              :searchable="false"
              :allow-empty="true"
              select-label
              selected-label
            >
            </multiselect>
          </v-flex>
          <v-flex xs12 sm3 class="form-control pa-1">
            <label>{{ $t('วันที่สมัคร - start') }}</label>
            <DatePickerWithoutButton v-model="filter.dateFrom">
              <input
                readonly
                :value="formatdate(filter.dateFrom)"
                class="form-control"
                type="text"
              />
            </DatePickerWithoutButton>
          </v-flex>
          <v-flex xs12 sm3 class="form-control pa-1">
            <label>{{ $t('วันที่สมัคร - end') }}</label>
            <DatePickerWithoutButton v-model="filter.dateTo">
              <input readonly :value="formatdate(filter.dateTo)" class="form-control" type="text" />
            </DatePickerWithoutButton>
          </v-flex>
          <v-flex xs12 sm3 class="form-control pa-1">
            <label>{{ $t('Status') }}</label>
            <multiselect
              v-model="filter.member_status"
              :options="memberStatusOptions"
              :searchable="false"
              :allow-empty="true"
              select-label
              selected-label
              track-by="value"
              label="label"
            >
            </multiselect>
          </v-flex>
          <v-flex xs3 style="display: flex; justify-content: flex-end; align-items: center">
            <v-btn outline color="grey" @click="clearsearch">{{ $t('Clear Search') }}</v-btn>
            <v-btn depressed color="primary" @click="onsearch">
              <i class="fas fa-search mr-1"></i>
              {{ $t('Search') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </div>
      <v-layout row wrap class="ma-0 pa-0">
        <v-flex xs12 sm9>
          <div>
            <v-pagination
              v-model="pageNumber"
              :total-visible="6"
              :length="pagelength"
              @input="changePage"
            ></v-pagination>
          </div>
        </v-flex>
        <v-flex xs12 sm3 class="text-xs-right pt-3">
          <span class="pr-1">Total:</span>
          <span class="primary--text" style="font-size: 18px; font-weight: 700">{{ total }}</span>
          <!-- <v-btn outline @click="showsearch = true"><v-icon>search</v-icon>ค้นหา</v-btn> -->
        </v-flex>
      </v-layout>
    </div>

    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      hide-actions
      :pagination.sync="pagination"
      class="elevation-1"
    >
      <template #items="props">
        <tr
          :style="{
            backgroundColor: props.item.member_status == 'true' ? '#e6ffe6' : 'white',
            color: props.item.is_block ? '#FF0000' : '#000'
          }"
        >
          <td class="text-xs-center">{{ props.item.is_block ? 'สมาชิกที่ถูก block' : '-' }}</td>
          <td>{{ props.item.toa_member_id }}</td>
          <td>{{ props.item.first_name }} {{ props.item.last_name }}</td>
          <td>{{ props.item.department_store }}</td>
          <td>{{ props.item.branch }}</td>
          <td>{{ props.item.phone_number }}</td>
          <td>{{ props.item.email || '-' }}</td>
          <td>{{ props.item.linename }}</td>
          <td>{{ props.item.job }}</td>
          <td>{{ props.item.points }}</td>
          <td>
            <!-- <template v-if="props.item.identity_number_image"> -->
            <v-btn icon :disabled="!props.item.identity_number_image">
              <i
                style="font-size: 27px"
                class="far fa-id-card"
                :class="props.item.identity_number_image ? 'primary--text' : 'grey--text'"
                @click="showImage(props.item)"
              />
            </v-btn>
            <!-- </template>
            <template v-else>
              <i style="font-size: 27px" class="grey--text far fa-id-card" />
            </template> -->
          </td>
          <td>{{ props.item.tier || '-' }}</td>
          <td class="text-xs-right">
            <v-btn icon @click="showEdit(props.item)"> <v-icon>edit</v-icon></v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
    <div>
      <v-pagination
        v-model="pageNumber"
        :total-visible="6"
        :length="pagelength"
        @input="changePage"
      ></v-pagination>
    </div>
    <v-dialog v-model="showImageDialog" width="550px">
      <v-card class="pa-2">
        <div style="display: flex; justify-content: center">
          <v-img
            v-if="showImageDialog"
            :src="currentShowImage"
            style="max-width: 400px"
            @click="showImageDialog = false"
          ></v-img>
        </div>
        <div class="text-xs-center pt-1">
          <v-btn
            depressed
            color="primary"
            @click="
              showImageDialog = false
              currentShowImage = ''
            "
          >
            <span>ปิด</span>
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editModal" persistent width="950px">
      <v-card v-if="editModal">
        <MemberEdit
          :editdata="editdata"
          @onsave="oneditmember"
          @close="editModal = false"
        ></MemberEdit>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import MemberEdit from './MemberEdit.vue'
import DatePickerWithoutButton from '@/components/elements/DatePickerWithoutButton.vue'
import api from '@/api'
import SearchMember from './SearchMember.vue'
import { mapGetters } from 'vuex'
import exportxlsx from '@/components/elements/exportxlsx.vue'
export default {
  components: {
    Multiselect,
    SearchMember,
    DatePickerWithoutButton,
    MemberEdit,
    exportxlsx
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        return Math.ceil(this.total / 10)
      } else {
        return 1
      }
    },
    branchOptions() {
      const tempData = this.$store.state.toacrmbranch.filter(({ department_store }) =>
        this.filter.departmentStore ? department_store === this.filter.departmentStore : true
      )
      if (tempData && tempData.length > 0) {
        return [...new Set(tempData.map((el) => el.branch))]
      } else {
        return []
      }
    },
    departmentOptions() {
      const tempData = this.$store.state.toacrmbranch
      if (tempData && tempData.length > 0) {
        return [...new Set(tempData.map((el) => el.department_store))]
      } else {
        return []
      }
    }
  },
  data() {
    return {
      pagination: { rowsPerPage: -1, sortBy: '' },
      editModal: false,
      editdata: '',
      showImageDialog: false,
      currentShowImage: '',
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      showsearch: false,
      filter: {
        name: '',
        identityNumber: '',
        phoneNumber: '',
        email: '',
        branch: '',
        dateFrom: '',
        dateTo: '',
        member_status: '',
        toa_member_id: '',
        tier: '',
        departmentStore: '',
        job: ''
      },
      loading: false,

      items: [],
      headers: [
        { text: 'สถานะ', value: 'is_block' },
        { text: 'รหัสสมาชิก', value: 'toa_member_id' },
        { text: 'ชื่อ-นามสกุล', value: 'first_name' },
        { text: 'ห้าง', value: 'department_store' },
        { text: 'สาขา', value: 'branch' },
        { text: 'เบอร์โทร', value: 'phone_number' },
        { text: 'อีเมล', value: 'email' },
        { text: 'ไลน์', value: 'linename' },
        { text: 'อาชีพ', value: 'job' },
        { text: 'คะแนน', value: 'points' },
        { text: 'บัตรประชาชน', value: 'idcard' },
        { text: 'Tier', value: 'tier' },
        { text: '', value: '', sortable: false }
      ],
      member_status: null,
      showAdvancedSearch: false,
      tierOptions: ['New Member', 'Regular Member', 'Loyalty Member', 'Inactive Member'],
      jobOptions: [
        'ผู้รับเหมา',
        'ช่างสี',
        'ช่างไม้',
        'ช่างฝ้า',
        'ช่างปูกระเบื้อง',
        'ช่างซ่อมบำรุง/ช่างฝีมือทั่วไป',
        'สถาปนิก / อินทีเรีย /  ดีไซเนอร์',
        'อื่นๆ'
      ],
      memberStatusOptions: [
        { label: 'สมาชิกปกติ', value: false },
        { label: 'สมาชิกที่ถูก block', value: true }
      ]
    }
  },
  mounted() {
    this.getData(false, true)

    if (this.$store.state.toacrmbranch && this.$store.state.toacrmbranch.length == 0) {
      this.getBranch()
    }
  },
  methods: {
    getXlsxData() {
      return new Promise(async (resolve) => {
        var data = await this.getData(true)

        resolve(
          data.map((el) => {
            if (el.member_status == 'true') {
              this.member_status = 'อนุมัติแล้ว'
            } else {
              this.member_status = 'None'
            }

            return {
              รหัสสมาชิก: el.toa_member_id,
              เลขบัตรประชาชน: el.identity_number,
              ชื่อลูกค้า: el.first_name + ' ' + el.last_name,
              วันเกิด: moment(el.dob).format('DD/MM/YYYY'),
              เบอร์โทร: el.phone_number,
              อีเมล: el.email,
              อาชีพ: el.job,
              ห้าง: el.department_store,
              สาขา: el.branch,
              ภาพบัตรประชาชน: el.identity_number_image,
              Tier: el.tier,
              สถานะการตรวจสอบข้อมูล: this.member_status,
              ผู้ตรวจ: el.approve_by,
              วันที่ตรวจ: el.approve_timestamp
                ? moment(el.approve_timestamp).format('DD/MM/YYYY HH:mm')
                : '',
              คะแนนคงเหลือ: el.points,
              วันที่สมัครสมาชิก: el.registertimestamp
                ? moment(el.registertimestamp).format('DD/MM/YYYY HH:mm')
                : ''
            }
          })
        )
      })
    },
    oneditmember() {
      this.editModal = false
      this.getData()
    },
    showEdit(item) {
      this.editdata = item
      this.editModal = true
    },
    showImage(item) {
      this.currentShowImage = item.identity_number_image
      this.showImageDialog = true
    },
    changePage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.pageNumber * this.limit - this.limit

        this.getData(false, true)
      }
    },
    onsearch() {
      this.getData()
      this.showsearch = false
    },
    clearsearch() {
      this.filter = {
        name: '',
        identityNumber: '',
        phoneNumber: '',
        email: '',
        branch: '',
        dateFrom: '',
        dateTo: '',
        member_status: '',
        toa_member_id: '',
        tier: '',
        departmentStore: '',
        job: ''
      }
      this.onsearch()
    },
    formatdate(date) {
      if (date) {
        return moment(date).format('DD/MM/YYYY')
      } else return ''
    },

    getData(getall = false, isFirst = false) {
      return new Promise((resolve) => {
        if (!isFirst) {
          this.offset = 0
          this.pagetmp = 1
          this.pageNumber = 1
        }
        var data = {
          pageid: this.selectedBot.pageid,
          name: this.filter.name, // filter ชื่อ
          identityNumber: this.filter.identityNumber, // filter บัตรปชช.
          phoneNumber: this.filter.phoneNumber, // filter เบอร์โทร
          email: this.filter.email, // filter email
          branch: this.filter.branch, // filter ชื่อสาขา
          dateFrom: this.filter.dateFrom, // YYYY-MM-DD
          dateTo: this.filter.dateTo, // YYYY-MM-DD
          is_block: this.filter.member_status ? this.filter.member_status.value : '',
          toa_member_id: this.filter.toa_member_id,
          tier: this.filter.tier,
          departmentStore: this.filter.departmentStore,
          job: this.filter.job
        }

        if (!getall) {
          Object.assign(data, {
            limit: this.limit,
            offset: this.offset
          })
        }
        this.loading = true
        api.getmembertoacrm(data, (err, response) => {
          this.loading = false
          if (response && response.responsecode == 200) {
            if (!getall) {
              this.items = response.data
              this.total = response.total
            }
            resolve(response.data)
          }
        })
      })
    },
    getBranch() {
      const vm = this
      try {
        api.gettoacrmBranch(
          {
            pageid: vm.selectedBot.pageid
          },
          (err, response) => {
            if (err) {
              console.error(err)
              return
            }

            const tempBranches = response.data
            vm.$store.state.toacrmbranch = tempBranches
          }
        )
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style lang="scss">
@import 'photoviewer/dist/photoviewer.css';
</style>



// WEBPACK FOOTER //
// src/components/view/template/toacrm/Member.vue